import { useState } from 'react';
import Button from './Button';
import { Check, Copy } from 'lucide-react';

type CopyButtonProps = {
    text: string;
    label?: string;
} & Pick<React.ComponentProps<typeof Button>, 'className' | 'disabled' | 'fullWidth' | 'size' | 'variant'>;

export default function CopyButton({
    text,
    label,
    className,
    disabled,
    fullWidth,
    size = 'sm',
    variant = 'outline',
}: CopyButtonProps) {
    const [isCopied, setIsCopied] = useState(false);
    const handleCopy = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        if (disabled) {
            return;
        }
        navigator.clipboard.writeText(text);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    }

    return (
        <Button
            size={size}
            fullWidth={fullWidth}
            variant={variant}
            icon={isCopied ? <Check size={16} /> : <Copy size={16} />}
            onClick={handleCopy}
            disabled={disabled}
            className={className}
        >
            {label}
        </Button>
    );
}